import { Component, OnInit, OnDestroy, AfterViewInit, ViewChild } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { StateService } from '../services/state.service';
import { VehicleService } from '../services/vehicle.service';
import { ApiService } from '../services/api.service';
import { Subject } from 'rxjs';
import * as moment from 'moment';
import jsPDF from 'jspdf';

@Component({
  selector: 'app-vehicles',
  templateUrl: './vehicles.component.html',
  styleUrls: ['./vehicles.component.css']
})
export class VehiclesComponent implements OnInit {

  @ViewChild(DataTableDirective, {static: false}) datatableElement: DataTableDirective;
  vehicles:any = [];
  vehicleGroups:any = [];
  vehicleStatusGroups:any = [];
  listedVehicles:any = [];
  initState = true;
  filterList = 'All';
  map:any = {};
  
  vehicleSubs:any;
  vehicleSelected:any;

  chasisNo = "";
  dealerName = "";
  dealerAddress = "";
  installDate = "";
  activationDate = "";
  expiryDate = "";
  issueDate = "";

  certGenerateVehicle:any = "";
  
  constructor(private stateSvc: StateService, private vehicleSvc: VehicleService, private apiSvc: ApiService) {
	  this.detailVehicle = this.detailVehicle.bind(this);
	  this.generateCert = this.generateCert.bind(this);
  }

  ngOnInit(): void {
	this.stateSvc.mapInstance
	.subscribe((map) => {
		this.map = map;
	});
	this.vehicleSubs = this.stateSvc.vehicles
	.subscribe((result) => {
		this.vehicles = result;
		if(this.initState){
			//this.stateSvc.setVehicleFiltered(result);
		}
		if(this.filterList != 'All'){
			this.filterChanged(this.filterList)
		}else{
			this.stateSvc.setVehicleFiltered(result);
		}
		this.stateSvc.vehicleStatusGroups
		.subscribe((statuses) => {
			this.vehicleStatusGroups = statuses;
		});
		this.stateSvc.vehicleGroups
		.subscribe((groups) => {
			this.vehicleGroups = groups;
		});
		if(result?.length > 0){
			this.initState = false;
		}
	});
	this.stateSvc.vehicleFiltered
	.subscribe((filtered) => {
		this.listedVehicles = filtered;
		this.rerender();
	});
	this.stateSvc.dropDownFilterValue
	.subscribe((dropdownValue) => {
		this.filterList = dropdownValue;
	});
  }
  
  ngOnDestroy(){
	this.vehicleSubs.unsubscribe();
  }
  
  toTitleCase(str) {
	return str.replace(/\w\S*/g, function (txt) {
		return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase().replace(/_/g, ' ');
	});  
  }
  
  filterChanged(selectValue){
	let result = [];  
	switch (selectValue) {
		case 'Selected':
			result = this.filterVehicleByShownOnMap();
			break;
		case 'All':
			result = this.vehicles;
			break;
		case 'Active':
			result = this.filterVehicleByStatus('active');
			break;
		case 'Idle':
			result = this.filterVehicleByStatus('idle');
			break;
		case 'Stop':
			result = this.filterVehicleByStatus('stop');
			break;
		default:
			result = this.filterVehicleByGroup(selectValue);
			break;
	}
	this.stateSvc.setDropDownFilterValue(selectValue);
	this.stateSvc.setVehicleFiltered(result);
  }
  
  filterVehicleByStatus(status){
	let tmpResult = [];
	this.vehicles?.forEach((vehicle) => {
		if(vehicle.status == status){
			tmpResult.push(vehicle);
		}
	});
	
	return tmpResult;
  }
  
  filterVehicleByGroup(selectValue){
	let tmpResult = [];
	this.vehicles?.forEach((vehicle) => {
		if (vehicle.groupname == selectValue) {
			tmpResult.push(vehicle);
		}
	});
	
	return tmpResult;
  }
  
  filterVehicleByShownOnMap(){
	let tmpResult = [];
	this.vehicles?.forEach((vehicle) => {
		if (vehicle.shownOnMap) {
			tmpResult.push(vehicle);
		}
	});
	
	return tmpResult;
  }

  getCircularReplacer(){
	const seen = new WeakSet();
	return (key, value) => {
		if (typeof value === "object" && value !== null) {
		if (seen.has(value)) return; // Remove circular reference
		seen.add(value);
		}
		return value;
	};
	};
  
  detailVehicle(vehicleunit){
	let tempVhcl:any = {}
	this.vehicles?.forEach((vhcl) => {
		if(vhcl.unitid == vehicleunit){
			tempVhcl = vhcl;
			return;
		}
	});
	this.vehicleSvc.clearAllLocalVehicleOnMap();
	localStorage.setItem('jump_direct', JSON.stringify(tempVhcl,this.getCircularReplacer()));
	// this.vehicleSvc.updateVehicleOnMap(this.vehicles, this.listedVehicles, tempVhcl.unitid, this.map, true);
	this.apiSvc.navigateInternal('map');
  }
  
	rerender() {
		// get user info from session
		let userString = sessionStorage.getItem('user');
		// parse into JSON format, local only store as single string
		let user:any = JSON.parse(userString);
		let options = {
			data: this.listedVehicles,
			//pageLength: 25,
			paging:false,
			responsive: false,
			scrollX: true,
			searching: true,
			destroy: true,
			buttons: [
				{
					extend: 'colvis',
					className: 'fa fa-eye',
					text: '',
				}, 
				{
					extend: 'excelHtml5',
					exportOptions: {
						columns: ( idx, data, node ) => {
							 let table_id = node.getAttribute('aria-controls');
							  return $('#oncore1').DataTable().column( idx ).visible();
						  }
					},
					className: 'fa fa-file-excel-o',
					text: '',
					title: (user.username).toUpperCase() + ' - Fleet Report - Generated at ' + moment().format('YYYY-MM-DD HH:mm:ss'),
				}, {
					extend: 'pdfHtml5',
					orientation: 'landscape',
					pageSize: 'A4',
					className: 'fa fa-file-pdf-o',
					text: '',
					exportOptions: {
						columns: ( idx, data, node ) => {
							 let table_id = node.getAttribute('aria-controls');
							  return $('#oncore1').DataTable().column( idx ).visible();
						  }
					},
					title: (user.username).toUpperCase() + ' - Fleet Report - Generated at ' + moment().format('YYYY-MM-DD HH:mm:ss'),
				}
			],
			"columns": [
				// {
				//     "className": 'details-control',
				//     "orderable": false,
				//     "data": null,
				//     visible: scope.hasDetails,
				//     "defaultContent": '<i class="fa fa-plus-circle color-oncore-blue" aria-hidden="true"></i>'
				// },
				// {
				// 	"data": "event",
				// 	render: function (data, type, source) {
				// 		return '<i class="generate-cert fa fa-download" style="cursor:pointer"  data-vehicleunitid=\'' + source.unitid + '\'></i>&nbsp;&nbsp;'
				// 	},
				// 	title: "Certificate"
				// },
				{
					"data": "event",
					render: (data) => {
						return '<div class="table-event"><i class="fi event-' + data.toLowerCase().replace(/ /g, '-') + '"></i>&nbsp;&nbsp;' + this.toTitleCase(data.toLowerCase().replace(/_/g, ' ')) + '</div>';
					},
					title: "Status"
				},
				{
					"data": "updated",
					render: function (data) {
						if(data != '-'){
							return data.format('DD-MM-YYYY HH:mm:ss').toString();
						}else{
							return '-'
						}
					},
					title: "Last Update"
				},
				{
					"data": "description",
					render: function (data, type, source) {
						return '<a class="show-vehicle" style="cursor:pointer" data-vehicleunitid=\'' + source.unitid + '\'>' + data + '</a>'
					},
					title: "Vehicle"
				},
				{
					"data": "direction",
					render: function (data, type, source) {
						return '<i class="fleet-direction fa fa-arrow-circle-o-up wind-' + data.toLowerCase() + '"></i>&nbsp;&nbsp;' + data
					},
					title: "Heading"
				},
				{
					"data": "engine",
					title: "Engine"
				},
				{
					"data": "odometerInt",
					render: function (data) {
						return data?? 0;
					},
					title: "Odometer"
				},
				{
					"data": "speed",
					render: function (data) {
						return parseInt(data ?? 0, 10);
					},
					title: "Speed (km/h)"
				},
				{
					"data": "level",
					render: function (data:any, type, source:any) {
						let upper:any = parseFloat(data);
						let lower:any = parseFloat(source.tankvolume);
						let dvdFs:any = upper / lower;
						let thenTms = dvdFs * 100;
						let perc = 0;
						perc = parseInt(thenTms.toString(), 10);
						if (lower == 0) {
							return '-';
						}

						return parseInt(source.fuelValue, 10) + ' (' + perc + '%)';
					},
					title: "Fuel (l)"
				},
				{
					"data": "batteryPercent",
					title: "Battery"
				},
				// { "data": "distance" },
				// { "data": "duration" },
				{
					"data": "drivernamedefault",
					render: function (data) {
						return data? data : '-';
					},
					title: "Driver"
				},
				{
					"data": "location",
					render: function (data, type, source) {
						if(source.location != source.coordinate){
							return data? data : '-';
						}else{
							return '<a class="coord-to-geocode" style="cursor:pointer" data-vehicleunitid=\'' + source.unitid + '\'>' + data + '</a>'
						}
					},
					title: "Location"
				}
			],
			"dom": "<'datatables-heading-elements'Bf<'visible-group'>>rti",
			"order": [[1, 'asc']],
			"stateSave": true
		};
		
		if($('#oncore1') && $('#oncore1_wrapper')[0]){
			//$('#oncore1_wrapper').remove();
			//$('#vhcl-list').html('<table id="oncore1" class="display table nowrap" cellspacing="0" width="100%"></table>');
		}
		if(this.listedVehicles.length > 0){
			let tblFleet = $('#oncore1').DataTable(options);
			setTimeout(() => {
				$('#vhcl-list').css('display', 'block');
				tblFleet.columns.adjust().draw();
			}, 1000);
		}
		setTimeout(() => {
			$.each($('#oncore1').children('tbody').find('tr'), function(){
				$(this).children('td:last').css({'white-space':'unset', 'min-width':'255px'});
			});
			let self = this;
			$('.show-vehicle').click(function(){
				$("body").css("cursor", "progress");
				$(this).attr('disabled','disabled');
				self.detailVehicle($(this).attr('data-vehicleunitid'));
			});
			$('.generate-cert').click(function(){
				$('#fieldOpt').show().addClass('in');
				$('#fieldOptBackdrop').show().addClass('in');
				self.certGenerateVehicle = $(this).attr('data-vehicleunitid');
				// self.generateCert($(this).attr('data-vehicleunitid'));
			});
			$('.coord-to-geocode').click(function(){
				let vid = $(this).attr('data-vehicleunitid');
				let vhcl:any = {};
				self.vehicles?.forEach((vhc) => {
					if(vhc.unitid == vid){
						vhcl = vhc;
						return;
					}
				});
				if(vhcl?.unitid){
					self.vehicleSvc.reverseGeocode(vhcl.lat, vhcl.lon)
					.subscribe((res) => {
						if(res && res != ""){
							vhcl.geolocation = res;
							vhcl.location = res;
							self.vehicleSvc.getVehicleOuts().subscribe((vhc) => {
								
							});
						}
					});
				}
			});
		}, 1000);
		
	}

	generateCert(vehicleunit) {
		let tempVhcl:any = {}
		this.vehicles?.forEach((vhcl) => {
			if(vhcl.unitid == vehicleunit){
				tempVhcl = vhcl;
				return;
			}
		});console.log('tempVhcl',tempVhcl)

		const doc = new jsPDF('p', 'mm', 'a4');

		const img = new Image();
		img.src = 'assets/images/backgrounds/cert_bg.jpeg'; // your JPEG in assets

		img.onload = () => {

			// Add background image (full page)
			doc.addImage(img, 'JPEG', 0, 0, 210, 297); // A4 size in mm

			// Overlay text
			doc.setFont('Arial');
			doc.setFontSize(13);
			doc.setTextColor(0, 0, 0);

			doc.text(moment(this.issueDate).format('DD/MM/YYYY'), 163.5, 7.5); // (x, y)

			doc.setFontSize(14);
			doc.text('Oncore Fleet', 65.5, 164);
			doc.text(tempVhcl.description, 65.5, 169.5);
			doc.text(this.chasisNo, 65.5, 175.5);
			doc.text((tempVhcl.unitid).toString(), 65.5, 181.5);
			doc.text(moment(this.installDate).format('DD/MM/YYYY'), 65.5, 187.1);
			doc.text(this.dealerName, 65.5, 192.7);

			let addrByLines = (this.dealerAddress).split(/\r?\n/);
			let addrFirst = 198.5;
			addrByLines.forEach((addrLn, ixd) => {
				doc.text(addrLn, 65.5, addrFirst + (ixd * 6));
			});
			// doc.text(this.dealerAddress, 65.5, 198.5);
			// doc.text('Light Industrial Park, Jalan Batu Kawa/Matang,', 65.5, 204.5);
			// doc.text('93250 Kuching, Sarawak.', 65.5, 210.5);

			doc.text('https://web.oncore.com.my/#/', 65.5, 225.8);
			doc.text(tempVhcl.username, 65.5, 231.5);
			doc.text(moment(this.activationDate).format('DD/MM/YYYY'), 65.5, 237.5);
			doc.text(moment(this.expiryDate).format('DD/MM/YYYY'), 65.5, 243);

			// Save PDF
			doc.save(tempVhcl.description+'.pdf');

			$('#fieldOptBackdrop').hide().removeClass('in');
			$('#fieldOpt').hide().removeClass('in');
		};
	}

	cancelCert(){
		$('#fieldOptBackdrop').hide().removeClass('in');
		$('#fieldOpt').hide().removeClass('in');
	}

}
